import React, { forwardRef } from "react";
import { PageFooter } from "./PageFooter";
import StaticHeader from "../layout/header/StaticHeader";
import { PageProps, PageRef, StyledPage } from "./Page";

const StaticScreen = forwardRef<PageRef | null, PageProps>(
  ({ children, footer = false, ...rest }, ref) => {
    return (
      <>
        <StaticHeader />
        <StyledPage ref={ref} {...rest}>
          {children}
        </StyledPage>
        {footer ? <PageFooter /> : null}
      </>
    );
  }
);
export default StaticScreen;
